import React from 'react';

import {useChatStore} from '../../store/slices/chatStore';
import './LoadBar.style.scss';

const LoadBar = () => {
  const loadBarStage = useChatStore((state) => state.chatStageFlow);

  return (
    <div className="load-bar-container" data-testid="load-bar">
      <div style={{width: `${loadBarStage}%`}} />
    </div>
  );
};

export default LoadBar;
